import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccApplicationStatusId } from '@interfaces';
import { DomainDataService } from '../../../../../services';
import { AdmissionsAreaService } from '../../../admissions-area.service';
import { AdmissionsAcceleratorsService } from '../../admissions-accelerators.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'admissions-accelerators-accelerator-seats-view-part',
	standalone: true,
	templateUrl: './accelerator-seats.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [GridContentWidget],
})
export class AdmissionsAcceleratorsAcceleratorSeatsViewPart {
	private readonly domainDataService = inject(DomainDataService);
	private readonly util = inject(UtilityService);
	private readonly pageService = inject(AdmissionsAcceleratorsService);
	private readonly admissionsAreaService = inject(AdmissionsAreaService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.util, this.domainDataService, this.dialogService, this.admissionsAreaService.app, this.admissionsAreaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accApplications = computed(() => this.admissionsAreaService.admissionsData()?.accApplications.filter(appl =>
		appl.offeredSeatAccId !== null && appl.offeredSeatAccId !== undefined &&
		(appl.accApplicationStatusId === AccApplicationStatusId.ConsiderOfferingSeat ||
			appl.accApplicationStatusId === AccApplicationStatusId.SeatOffered ||
			appl.accApplicationStatusId === AccApplicationStatusId.SeatAccepted)) ?? []);

}
